import { render, staticRenderFns } from "./axis.vue?vue&type=template&id=30a8f1eb&scoped=true&"
import script from "./axis.vue?vue&type=script&lang=js&"
export * from "./axis.vue?vue&type=script&lang=js&"
import style0 from "./axis.vue?vue&type=style&index=0&id=30a8f1eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a8f1eb",
  null
  
)

export default component.exports